<template>
  <tr class="even:bg-gray-50">
    <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
      {{ subscription.contact.full_name }}
    </td>
    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
      <span
        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
        :class="[subscription.active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800']"
      >
        {{ subscription.active ? 'Subscribed' : 'Unsubscribed' }}
      </span>
    </td>
    <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
      <UnsubscribeAction
        v-if="subscription.active"
        :subscription="subscription"
        @unsubscribed="$emit('changed')"
      />
    </td>
  </tr>
</template>

<script>
import UnsubscribeAction from './UnsubscribeAction.vue';

export default {
  components: { UnsubscribeAction },
  props: {
    subscription: {
      type: Object,
      required: true,
    },
  },
};
</script>
